import React from "react";
import { Box, Flex, Heading, Image, Text } from "@catchoftheday/cg-components";
import { ASSET_PERSON_DIVISION_BOXES } from "../../../../consts";
export const TransferReason = () => {
    return (<Flex mb={20} flexWrap="wrap" alignItems="center">
      <Image width={{
            xs: "100%",
            md: "40%",
        }} height="auto" maxWidth={{
            xs: "360px",
            md: "426px",
        }} ml={{
            xs: "auto",
            md: 0,
        }} mr="auto" src={ASSET_PERSON_DIVISION_BOXES} alt="Person carrying boxes with division logos on them"/>
      <Box width={{
            xs: "100%",
            md: "60%",
        }} maxWidth="600px" mx="auto" pl={{
            xs: 0,
            md: 5,
        }} color="onePass.textPrimary">
        <Heading.h2 fontSize={{
            xs: "xl",
            md: "3xl",
        }} fontWeight="bold" mb={{
            xs: 4,
            md: 6,
        }}>
          Why do I need to transfer?
        </Heading.h2>
        <Text fontSize="base" m={0} fontWeight="medium">
          The OnePass membership provider is changing from Catch to Wesfarmers
          One Pass Pty Ltd to bring you more benefits. To access your new
          membership benefits, such as free delivery on eligible items when
          shopping at Kmart and Target, you'll need to create a new OnePass
          account.
          <br />
          <br />
          After creating a new account, your payment will transfer across to the
          new provider and you will no longer be billed by Catch. You'll also
          start to see Wesfarmers appear on your bank statement.
        </Text>
      </Box>
    </Flex>);
};
